import { render, staticRenderFns } from "./SpontaneousSurveySettings.vue?vue&type=template&id=82cf37c8&scoped=true&"
import script from "./SpontaneousSurveySettings.vue?vue&type=script&lang=ts&"
export * from "./SpontaneousSurveySettings.vue?vue&type=script&lang=ts&"
import style0 from "./SpontaneousSurveySettings.vue?vue&type=style&index=0&id=82cf37c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82cf37c8",
  null
  
)

export default component.exports